import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { CardiacService } from '../../procedures/cardiac/services/cardiac.service'
import * as actions from '../store/options.actions'

export function* setDefibTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const cardiacService = new CardiacService(serviceId)
  try {
    const response: IOptionsResponse = yield call([cardiacService, cardiacService.getDefibTypeOptions])
    const { entity } = response
    yield put(actions.setDefibTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setDefibTypeOptions() error: ${e}`))
  }
}
export function* setDefibTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDefibTypeOptions)
}
